import React, { useEffect, useState } from 'react';
import { COMPLIANCE_COLOR } from '../../store-details/components/PlanogramComplianceControlCenter';

export type PogResultStatus = 'compliant' | 'non_compliant' | 'out' | 'faceover';

const STATUS_OPTIONS: PogResultStatus[] = ['compliant', 'non_compliant', 'out', 'faceover'];

const STATUS_LABEL: Record<PogResultStatus, string> = {
  compliant: 'Compliant',
  non_compliant: 'Non-compliant',
  out: 'Out',
  faceover: 'Faceover',
};

interface GtPogStatusEditorProps {
  ilItemId: number;
  currentStatus: PogResultStatus | null;
  onApply: (ilItemId: number, status: PogResultStatus) => void;
}

export const GtPogStatusEditor: React.FC<GtPogStatusEditorProps> = ({
  ilItemId,
  currentStatus,
  onApply,
}) => {
  const [draft, setDraft] = useState<PogResultStatus>(currentStatus ?? 'compliant');

  useEffect(() => {
    setDraft(currentStatus ?? 'compliant');
  }, [currentStatus, ilItemId]);

  const dirty = draft !== currentStatus;

  const handleApply = () => {
    if (!dirty) return;
    onApply(ilItemId, draft);
  };

  const currentColor = currentStatus ? COMPLIANCE_COLOR[currentStatus] : '#9ca3af';

  return (
    <div className="bg-white border border-gray-200 rounded-lg p-4">
      <h4 className="text-lg font-semibold text-gray-900 mb-3">POG Compliance Status (GT)</h4>
      <div className="flex items-center gap-4 flex-wrap">
        <div className="flex items-center gap-2">
          <span className="text-sm font-medium text-gray-600">Current:</span>
          <span
            className="inline-flex items-center gap-1.5 px-3 py-1 rounded-md text-sm font-medium"
            style={{ backgroundColor: `${currentColor}22`, color: currentColor }}
          >
            <span
              className="inline-block w-2.5 h-2.5 rounded-full"
              style={{ backgroundColor: currentColor }}
            />
            {currentStatus ? STATUS_LABEL[currentStatus] : 'Not set'}
          </span>
        </div>

        <div className="flex items-center gap-2">
          <label htmlFor="gt-pog-status" className="text-sm font-medium text-gray-600">
            New:
          </label>
          <select
            id="gt-pog-status"
            value={draft}
            onChange={(e) => setDraft(e.target.value as PogResultStatus)}
            className="border border-gray-300 rounded-md px-2 py-1 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            {STATUS_OPTIONS.map((status) => (
              <option key={status} value={status}>
                {STATUS_LABEL[status]}
              </option>
            ))}
          </select>
        </div>

        <button
          type="button"
          onClick={handleApply}
          disabled={!dirty}
          className="px-4 py-1.5 bg-blue-600 text-white rounded-md text-sm font-medium hover:bg-blue-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Apply
        </button>
      </div>
    </div>
  );
};
